import React, { Fragment, useRef } from 'react';
import { Col, Form, FormLabel, InputGroup, Row } from 'react-bootstrap';
import Crud from '../../../components/Crud';
import { Editor } from '@tinymce/tinymce-react';
import Input from '../../../components/Input';
import config from '../../../config';
import schema from './schema';

const columns = [
  { header: 'Nome', property: 'nome', filter: true },
  { header: 'Estrutura pai', property: 'estruturaPai.nome', filter: true },
];

export default function EstruturaOrganizacionalPage() {
  const editorRef = useRef(null);
  return (
    <Crud
      header='Estrutra organizacional'
      columns={columns}
      path={`${config.api_path}/v1/estrutura-organizacional`}
      rows={20}
      schema={schema}
      form={({ state, handleChange, values, touched, isValid, errors }) => (
        <Fragment>
          <Row>
            <Col md={4}>
              <Form.Group>
                <FormLabel>Portal</FormLabel>
                <Input.AsyncSelect
                  id='portalCliente'
                  value={values.portalCliente}
                  onChange={handleChange}
                  isInvalid={errors.portalCliente}
                  path={`${config.api_path}/v1/transparencia/portalcliente`}
                  label={'${nome}'}
                  rowKey='id'
                  nullable
                  placeholder='Selecione um portal'
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.portalCliente}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <FormLabel>Estrutura pai</FormLabel>
                <Input.AsyncSelect
                  id='estruturaPai'
                  value={values.estruturaPai}
                  onChange={handleChange}
                  isInvalid={errors.estruturaPai}
                  path={`${config.api_path}/v1/estrutura-organizacional`}
                  label={'${nome}'}
                  rowKey='id'
                  nullable
                  placeholder='Selecione uma estrutura pai'
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.estruturaPai}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <FormLabel>Nome</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='nome'
                    value={values.nome}
                    onChange={handleChange}
                    isInvalid={errors.nome}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>
                  {errors.nome}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <FormLabel>Descrição</FormLabel>
          <Editor
            apiKey='g23uxmawmmddie2rzdpv01jdu0mp43tmtd1g63nf1ok2ec1h'
            onInit={(evt, editor) => (editorRef.current = editor)}
            value={values.texto}
            onEditorChange={(html) =>
              handleChange({ target: { id: 'texto', value: html } })
            }
            init={{
              height: 400,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
              content_style:
                'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            }}
          />

          {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
          {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
          {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
          {/* <pre>{JSON.stringify(isValid, null, 2)}</pre> */}
        </Fragment>
      )}
    ></Crud>
  );
}
